<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-tool`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 6.18V2.133c-.82.11-1.62.285-2.394.522C13.466 4.532 9 10.244 9 17c0 6.151 3.702 11.437 9 13.752V44a2 2 0 002 2h8a2 2 0 002-2V30.752c5.298-2.315 9-7.601 9-13.752 0-7.606-5.661-13.89-13-14.868V15h-4V6.18zM13 17c0-3.81 1.954-7.24 5-9.224v8.301c0 1.5 1.028 2.923 2.667 2.923h6.666C28.973 19 30 17.577 30 16.077V7.779c3.01 1.963 5 5.36 5 9.221 0 4.415-2.624 8.348-6.6 10.086L26 28.134V42H22V28.134l-2.398-1.047A11.002 11.002 0 0113 17z"/></svg>
</template>
<script>

export default {
  name: 'IconTool',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
